import { connect } from 'react-redux';
import { State } from 'store/types';

import View from './View';
import {
  fetchTrendingSearches,
  resetSearch,
} from 'store/searchSuggestions/action';
import { isEligible } from 'store/app/selector';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { RECENTLY_VIEWED_SEARCH_WIDGET } from 'constants/experiments';

const mapDispatchToProps = {
  fetchTrendingSearches,
  resetSearch,
};

const mapStateToProps = (state: State) => {
  const { searchSuggestions, remoteConfig, appReducer } = state;

  const {
    productSuggestions = [],
    otherSuggestions = [],
    searchAutoSuggestions = [],
    searchField = '',
  } = searchSuggestions;
  return {
    productSuggestions,
    otherSuggestions,
    searchAutoSuggestions,
    searchField,
    maxSearchHistoryCount: remoteConfig.configs.maxSearchHistoryCount,
    trendingSearchesToShow: remoteConfig.configs.trendingSearchesToShow,
    searchSuggestionIcons: remoteConfig.configs.searchSuggestionIcons,
    newScreen: isEligible(
      remoteConfig.configs?.AB?.searchSuggestion,
      appReducer.run
    ),
    isPopularSearchSuggestion: isEligible(
      remoteConfig.configs?.AB?.popularSearchSuggestion,
      appReducer.run
    ),
    showRecentlyViewedWidget: getEligibleForVariant(
      state,
      RECENTLY_VIEWED_SEARCH_WIDGET,
      'A'
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
